export interface Message {
  id: string;
  phone: string;
  message: string;
  timestamp: number;
  direction: "incoming" | "outgoing";
  type?: string;
  mediaUrl?: string;
}

export interface Conversation {
  phone: string;
  name?: string;
  messages: Message[];
  userState?: string;
  cursor?: string;
  cpf?: string;
  email?: string;
  lastMessage?: Message;
  unreadCount?: number;
}

export interface DeliveryManInfo {
  phone: string;
  name: string;
  cpf?: string;
  email?: string;
  address?: string;
  status?: string;
}

export interface CadastroInfo {
  cadastro: DeliveryManInfo[];
}

export enum ManagerVerbs {
  GetMessagesByTimestamp = "getMessagesByTimestamp",
  GetMessagesByPhoneAndTimestamp = "getMessagesByPhoneAndTimestamp",
  GetUserState = "getUserState",
  GetUserCursor = "getUserCursor",
  ResetUserState = "resetUserState",
  ResetCursor = "resetCursor",
}

export interface WhatsAppApiRequest {
  clientName: string;
  verb: ManagerVerbs;
  ops: string;
  start?: number;
  end?: number;
  phone?: string;
}

export interface WhatsAppApiResponse {
  messages?: Message[];
  userState?: string;
  cursor?: string;
}

export interface FundOption {
  key: string;
  value: string;
}

export interface OpsOption {
  key: string;
  value: string;
}

export type QueryType = "all" | "single" | null;
